/* eslint-disable no-nested-ternary */

import React from 'react';
import styled from 'styled-components';
import { VisitContents, Note, FormLink } from '@mummssoftware/common-ui';
import ManifestWidget from '@mummssoftware/manifest';
import defaults from '../../../../translations/en.json';
import { MFST, PPN, PPNNO, VST } from '../../../../constants';

const FocusText = styled.div`
  font-size: 1em;
  text-align: left;
  font-style: bold;
  min-width: 50vw;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 1vw;
  align-self: center;
  border: 4px solid;
  border-radius: 1vw;
  position: relative;
`;

// Can't use version from commonui, because that one needs a formdto.
// We want to pass a manifest dto
const Manifest = React.memo(
  ({ approvalDTO, mfst, agency, keycloak }) =>
    approvalDTO &&
    mfst && (
      <FormLink
        agency={agency}
        keycloak={keycloak}
        dto={mfst}
        patientNumber={approvalDTO.patientnumber}
        Widget={ManifestWidget}
      />
    ),
);

export const UnreviewedItemBody = ({
  entityDTO,
  pso,
  approvalDTO,
  agency,
  keycloak,
  theme,
}) => {
  const getApprovalUI = () => {
    let ui;
    switch (approvalDTO.entitytypeshortname) {
      case PPN:
      case PPNNO:
        ui = <Note ppn={entityDTO} pso={pso} />;
        break;
      case MFST:
        ui = (
          <Manifest
            approvalDTO={approvalDTO}
            mfst={entityDTO}
            agency={agency}
            keycloak={keycloak}
          />
        );
        break;
      case VST:
        ui = (
          <VisitContents
            dto={entityDTO}
            editing={false}
            agency={agency}
            keycloak={keycloak}
            patientNumber={approvalDTO.patientnumber}
            ManifestWidget={ManifestWidget}
          />
        );
        break;
      default:
        ui = <p>{defaults.fetchingData}</p>;
        break;
    }
    return ui;
  };

  return (
    <FocusText
      style={{
        minHeight: '40vh',
        maxHeight: '60vh',
        width: '50vw',
        backgroundColor: theme.palette.background.header,
      }}
    >
      {getApprovalUI()}
    </FocusText>
  );
};
